import { render, staticRenderFns } from "./HouseType.vue?vue&type=template&id=fbef6d18&scoped=true&"
import script from "./HouseType.vue?vue&type=script&lang=js&"
export * from "./HouseType.vue?vue&type=script&lang=js&"
import style0 from "./HouseType.vue?vue&type=style&index=0&id=fbef6d18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbef6d18",
  null
  
)

export default component.exports